import io from "socket.io-client";
import config from "./config";

// The client major version must match the deployed socket.io server:
// a 3.x/4.x client cannot connect to a 2.x server, and a 2.x client needs
// allowEIO3 on a 3.x/4.x server. The existing 2.4 client is kept because it
// is what the app currently ships with. Check the deployed server version
// before changing it.
let socket = null;

export const getSocket = () => {
  if (!socket) {
    socket = io(config.socketUrl, {
      autoConnect: false,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      transports: ["websocket"],
      timeout: 20000,
      // The server identifies the browser client by this query value.
      query: { username: config.socketUsername },
    });
  }
  return socket;
};

export const connectSocket = () => {
  const s = getSocket();
  if (!s.connected) s.connect();
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
